import { Tooltip } from 'antd'
import React from 'react'

const ShortlistIcon = ({
  title="Shortlist"
}) => {
  return (
    <Tooltip title={title}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M16.3826 8.27344H15.2834C15.0443 8.27344 14.817 8.38828 14.6764 8.58516L10.992 13.6945L9.32325 11.3789C9.18262 11.1844 8.95762 11.0672 8.71621 11.0672H7.617C7.46465 11.0672 7.37559 11.2406 7.46465 11.3648L10.385 15.4148C10.454 15.5111 10.5449 15.5896 10.6503 15.6437C10.7556 15.6978 10.8724 15.7261 10.9908 15.7261C11.1093 15.7261 11.226 15.6978 11.3314 15.6437C11.4368 15.5896 11.5277 15.5111 11.5967 15.4148L16.5326 8.57109C16.624 8.44688 16.535 8.27344 16.3826 8.27344Z"
          fill="#0FB680"
        />
        <path
          d="M12 1.5C6.20156 1.5 1.5 6.20156 1.5 12C1.5 17.7984 6.20156 22.5 12 22.5C17.7984 22.5 22.5 17.7984 22.5 12C22.5 6.20156 17.7984 1.5 12 1.5ZM12 20.7188C7.18594 20.7188 3.28125 16.8141 3.28125 12C3.28125 7.18594 7.18594 3.28125 12 3.28125C16.8141 3.28125 20.7188 7.18594 20.7188 12C20.7188 16.8141 16.8141 20.7188 12 20.7188Z"
          fill="#0FB680"
        />
      </svg>
    </Tooltip>
  )
}

export default ShortlistIcon
